import { useTranslation } from "react-i18next";
import { useLocation, useMatches } from "react-router-dom";

interface RouteHandle {
  crumbKey?: string;
}

export interface HelpScreen {
  /** Caminho real da URL atual (ex.: "/threads/123"). */
  path: string;
  /** Nome amigavel da tela (do ``handle.crumbKey`` da rota), se houver. */
  label?: string;
}

/**
 * Deriva a tela atual para enviar ao assistente de ajuda. E o unico
 * contexto vindo do cliente -- papel e times sao derivados da sessao
 * autenticada no backend.
 */
export function useHelpContext(): HelpScreen {
  const { t } = useTranslation("common");
  const location = useLocation();
  const matches = useMatches();

  // Pega o crumbKey do match mais profundo que tiver um (leaf da rota).
  let label: string | undefined;
  for (let i = matches.length - 1; i >= 0; i -= 1) {
    const crumbKey = (matches[i]?.handle as RouteHandle | undefined)?.crumbKey;
    if (crumbKey) {
      label = t(crumbKey);
      break;
    }
  }

  return { path: location.pathname, label };
}
